// frontend-react/src/pages/ForgotPassword.js

import React, { useState } from 'react';
import { forgotPassword } from '../api/api';
import { Link } from 'react-router-dom';
import './LoginPage.css'; // Χρησιμοποιούμε τα ίδια styles με τη σελίδα login

const ForgotPassword = () => {
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setMessage('');
        setError('');
        try {
            const response = await forgotPassword({ email });
            setMessage(response.data.message);
        } catch (error) {
            setError('An error occurred. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="login-page">
            <div className="login-container">
                <h1>ALGOSTOCK CAPITAL</h1>
                <h2>Reset Password</h2>
                
                {!message ? (
                    <form onSubmit={handleSubmit} className="login-form">
                        <p style={{color: 'var(--text-secondary)', fontSize: '0.9rem'}}>Enter your email to receive a password reset link.</p>
                        <input
                            type="email"
                            id="email"
                            placeholder="Your Email Address"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                        />
                        <button type="submit" disabled={loading}>
                            {loading ? 'Sending...' : 'Send Reset Link'}
                        </button>
                    </form>
                ) : (
                    <p className="success-message">{message}</p>
                )}

                {error && <p className="error-message">{error}</p>}
                
                <div className="auth-link" style={{ marginTop: '2rem' }}>
                    <Link to="/login">← Back to Login</Link>
                </div>
            </div>
        </div>
    );
};

export default ForgotPassword;